module.exports = __webpack_public_path__ + "img/Consultation.46518228.png";